// extracted by mini-css-extract-plugin
export default {"register":"Register_register__H6uKZ","registerForm":"Register_registerForm__uD5pr"};